<template>
  <header class="main-header">
    <!-- Brand: Logo & Title -->
    <router-link to="/mobile-menu" class="brand-link">
      <img :src="logo" alt="Logo Bếp A Diểng" class="brand-logo" />
      <span class="brand-title">Bếp A Diểng</span>
    </router-link>

    <!-- Single Dropdown Menu -->
    <div class="menu-wrapper" ref="dropdownRef">
      <button
        class="menu-toggle-btn"
        :class="{ 'is-active': open }"
        @click.stop="toggleDropdown"
        aria-label="Toggle Navigation Menu"
      >
        <span class="menu-icon">☰</span>
        <span class="menu-text">Menu</span>
        <span class="caret" :class="{ 'rotate': open }">▾</span>
      </button>

      <!-- Dropdown Content -->
      <transition name="dropdown-fade">
        <div v-if="open" class="dropdown-menu">
          <router-link to="/mobile-menu" class="dropdown-item" @click="closeDropdown">
            <span class="item-icon">📱</span>
            <span class="item-label">Gọi món / Bàn</span>
          </router-link>

          <router-link to="/kitchen" class="dropdown-item" @click="closeDropdown">
            <span class="item-icon">🍳</span>
            <span class="item-label">Màn hình Bếp</span>
          </router-link>

          <div class="dropdown-divider"></div>

          <router-link to="/history/today" class="dropdown-item" @click="closeDropdown">
            <span class="item-icon">📋</span>
            <span class="item-label">Đơn hôm nay</span>
          </router-link>

          <router-link to="/history/monthly" class="dropdown-item" @click="closeDropdown">
            <span class="item-icon">📊</span>
            <span class="item-label">Doanh thu tháng</span>
          </router-link>

          <div class="dropdown-divider"></div>

          <button class="dropdown-item logout-item" @click="handleLogout">
            <span class="item-icon">🚪</span>
            <span class="item-label">Đăng xuất</span>
          </button>
        </div>
      </transition>
    </div>
  </header>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { logout } from '../services/auth'
import logo from '@/assets/logoadieng.png'

const open = ref(false)
const dropdownRef = ref(null)

function toggleDropdown() {
  open.value = !open.value
}

function closeDropdown() {
  open.value = false
}

function handleLogout() {
  closeDropdown()
  if (confirm('Bạn có chắc chắn muốn đăng xuất?')) {
    logout()
  }
}

function handleClickOutside(e) {
  if (dropdownRef.value && !dropdownRef.value.contains(e.target)) {
    open.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>

<style scoped>
.main-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(135deg, #ff7a45 0%, #ff5a36 40%, #f43f5e 100%);
  padding: 6px 16px;
  height: 48px;
  box-shadow: 0 4px 16px rgba(244, 63, 94, 0.15);
  position: sticky;
  top: 0;
  z-index: 100;
  box-sizing: border-box;
}

.brand-link {
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  color: #fff;
  transition: opacity 0.2s;
}

.brand-link:hover {
  opacity: 0.92;
}

.brand-logo {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  object-fit: contain;
  background: rgba(255, 255, 255, 0.2);
  padding: 2px;
}

.brand-title {
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

.menu-wrapper {
  position: relative;
}

.menu-toggle-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  background: rgba(255, 255, 255, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.28);
  border-radius: 8px;
  color: #ffffff;
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
}

.menu-toggle-btn:hover,
.menu-toggle-btn.is-active {
  background: rgba(255, 255, 255, 0.28);
  border-color: rgba(255, 255, 255, 0.45);
}

.menu-icon {
  font-size: 1rem;
  line-height: 1;
}

.menu-text {
  font-size: 0.88rem;
}

.caret {
  font-size: 0.75rem;
  transition: transform 0.2s ease;
}

.caret.rotate {
  transform: rotate(180deg);
}

.dropdown-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 200px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.18), 0 4px 6px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
  padding: 6px;
  z-index: 1000;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 12px;
  border-radius: 8px;
  color: #334155;
  text-decoration: none;
  font-size: 0.88rem;
  font-weight: 500;
  transition: all 0.15s ease;
  width: 100%;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  box-sizing: border-box;
}

.dropdown-item:hover {
  background: #f1f5f9;
  color: #0f172a;
}

.dropdown-item.router-link-active {
  background: #fee2e2;
  color: #e11d48;
  font-weight: 600;
}

.item-icon {
  font-size: 1.05rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
}

.item-label {
  flex: 1;
}

.dropdown-divider {
  height: 1px;
  background: #f1f5f9;
  margin: 4px 0;
}

.logout-item {
  color: #e11d48;
}

.logout-item:hover {
  background: #fff1f2;
  color: #be123c;
}

/* Dropdown Animation */
.dropdown-fade-enter-active,
.dropdown-fade-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}

.dropdown-fade-enter-from,
.dropdown-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
</style>